import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import NavBar from '../../NavBar';
import { Footer } from '../Footer';
import { thankYouText } from '../../../constants/Footer/survey';

import './Survey.css';

export const ThankYou = () => {
  useEffect(() => {
    mixpanel.track('Survey Thank You page', {
      path: '/survey_thankyou',
    });
  }, []);

  return (
    <>
      <NavBar currentPath="survey" />
      <div className="surveyContainer">
        <img
          src="https://res.cloudinary.com/amunoali/image/upload/v1739819143/Survey.png"
          className="thankyouimg"
        />
        <h2 className="thankyouh2">{thankYouText.header}</h2>
        <p className="thankyoup"> {thankYouText.subheader}</p>
        <p>{thankYouText.othersurveys}</p>
        <ul className="surveylist">
          <li className="surveyLi">
            <a href="/survey_UIExperience" className="thankyouA">
              {thankYouText.uiExperience}
            </a>
          </li>
          <li className="surveyLi">
            <a href="/survey_finance_auto" className="thankyouA">
              {thankYouText.financeAuto}
            </a>
          </li>

          <li>
            <a href="/survey_finance_mortgage" className="thankyouA">
              {thankYouText.financeMortgage}
            </a>
          </li>
          <li>
            <a href="/survey_insurance_auto" className="thankyouA">
              {thankYouText.insuranceAuto}
            </a>
          </li>
          <li>
            <a href="/survey_insurance_home" className="thankyouA">
              {thankYouText.insuranceHome}
            </a>
          </li>
        </ul>
      </div>
      <Footer currentPath={'/survey'} />
    </>
  );
};
